import { getOmniLogger } from 'omni-package-react-logging';

const logger = getOmniLogger(process.env.REACT_APP_LOGGING_APPLICATION_NAME);
window.logger = logger;
export default logger;
